import { render, staticRenderFns } from "./reset-balances.vue?vue&type=template&id=5a45e33c&scoped=true"
import script from "./reset-balances.vue?vue&type=script&lang=js"
export * from "./reset-balances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45e33c",
  null
  
)

export default component.exports